import * as types from './mutation_types';

let mutations = {
    // 设置购物车数据
    [types.SET_CART_DATA] (state, cartData) {
        state.cartData = cartData;
    },
    [types.SET_CART_LIST] (state, cartList) {
        state.cartList = cartList || [];
    },
    // 设置顶部提示条的隐藏
    [types.SET_TIPS_HIDE] (state) {
        state.isTipsShow = false;
    },
    // 隐藏税金遮罩
    [types.SET_TAX_MASK_HIDE] (state) {
        state.isTaxMaskShow = false;
    },
    // 显示税金遮罩
    [types.SET_TAX_MASK_SHOW] (state) {
        state.isTaxMaskShow = true;
    },
    // 显示toast提示框
    [types.SET_TOAST_SHOW] (state) {
        state.isToastShow = true;
    },
    // 隐藏toast提示框
    [types.SET_TOAST_HIDE] (state) {
        state.isToastShow = false;
    },
    // 设置toast提示文本
    [types.SET_TOAST_TEXT] (state, text) {
        state.toastDesc = text;
    },
    // 显示loading图标
    [types.SET_LOADING_SHOW] (state) {
        state.isLoadingShow = true;
    },
    // 隐藏loading图标
    [types.SET_LOADING_HIDE] (state) {
        state.isLoadingShow = false;
    },
    // 编辑状态
    [types.SET_EDIT_TRUE] (state) {
        state.isEdit = true;
    },
    // 关闭编辑状态
    [types.SET_EDIT_FALSE] (state) {
        state.isEdit = false;
    },

    // 显示confirm弹窗
    [types.SET_CONFIRM_SHOW](state){
        state.confirm.isShow = true;
    },
    // 隐藏confirm弹窗
    [types.SET_CONFIRM_HIDE](state){
        state.confirm.isShow = false;
    },
    // 设置confirm数据
    [types.SET_CONFIRM_DATA](state, data){
        state.confirm.data = data;
    },
};


export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js